const MailToComp = ({children}) => {
    return (
        <a href="mailto:info@dsinnovators.com">
            {children || "info@dsinnovators.com"}
        </a>
    );
};

export default MailToComp;
